import React from "react";

export default function MobileMuteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-20 w-20 rounded-full transition delay-150 duration-300 ease-in-out"
      viewBox="0 0 56 56"
      fill="none"
    >
      <rect width="56" height="56" rx="10" fill="#2733C7" />
      <path
        d="M37.8017 27.3362C37.8624 32.4976 33.9849 36.8571 28.8517 37.3987V40.4612C28.8517 40.9859 28.4263 41.4112 27.9017 41.4112C27.377 41.4112 26.9517 40.9859 26.9517 40.4612V37.4487C21.8425 36.9094 17.9733 32.5862 18.0017 27.4487C17.9816 27.1093 18.1441 26.785 18.428 26.5979C18.7118 26.4108 19.074 26.3893 19.378 26.5416C19.6819 26.6939 19.8816 26.9968 19.9017 27.3362C19.8649 29.4933 20.6876 31.5765 22.1883 33.1264C23.689 34.6764 25.7445 35.5659 27.9017 35.5987C30.0588 35.5659 32.1144 34.6764 33.6151 33.1264C35.1158 31.5765 35.9384 29.4933 35.9017 27.3362C35.9017 26.8116 36.327 26.3862 36.8517 26.3862C37.3763 26.3862 37.8017 26.8116 37.8017 27.3362Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.3265 16.0865C30.5452 14.3006 27.8651 13.7605 25.5312 14.717C23.1973 15.6735 21.6671 17.9392 21.6515 20.4615V26.7115C21.6515 30.1633 24.4497 32.9615 27.9015 32.9615C31.3533 32.9615 34.1515 30.1633 34.1515 26.7115V20.4615C34.1413 18.8201 33.4857 17.2486 32.3265 16.0865ZM30.4019 24.724L26.6519 28.474C26.2805 28.8264 25.6983 28.8264 25.3269 28.474C24.9665 28.101 24.9665 27.5095 25.3269 27.1365L29.0769 23.3865C29.4429 23.0209 30.0359 23.0209 30.4019 23.3865C30.7622 23.7595 30.7622 24.351 30.4019 24.724ZM26.6519 23.7865L30.4019 20.0365C30.7622 19.6635 30.7622 19.072 30.4019 18.699C30.0359 18.3334 29.4429 18.3334 29.0769 18.699L25.3269 22.449C24.9665 22.822 24.9665 23.4135 25.3269 23.7865C25.6929 24.152 26.2859 24.152 26.6519 23.7865Z"
        fill="white"
      />
      <path
        d="M39.543 40.7147L38.7983 40.0473L39.543 40.7147C40.3179 39.8502 40.3179 38.4892 39.543 37.6246L19.5198 15.2848C18.6879 14.3567 17.2891 14.3567 16.4573 15.2848C15.6824 16.1493 15.6824 17.5103 16.4573 18.3748L36.4805 40.7147C37.3123 41.6428 38.7111 41.6428 39.543 40.7147Z"
        fill="white"
        stroke="#2733C7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
